import { useEffect, useMemo, useState } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { ALL_OPTION } from '@/common/constants';
import { OptionKey } from '@/common/types';
import { IInvoiceType } from '@/types';
import { checkIsAllOptionSelected, stateAllToggling } from '@/utils/handlers/dropdownStateAllToggling';

import { UNPAID_INVOICES_PAGE_SIZE } from '../../UnappliedFunds.constants';

export const useUnpaidInvoicesFilters = () => {
  const { page, setPage, perPage, setPerPage, searchString, setSearchString, currentSearch } =
    usePaginationParams(UNPAID_INVOICES_PAGE_SIZE);
  const [types, setTypes] = useState<OptionKey[]>([ALL_OPTION.key]);

  const typesAfterToggling = useMemo(() => stateAllToggling(types), [types]);
  const invoiceTypes = useMemo(
    () => (checkIsAllOptionSelected(types) ? [] : (typesAfterToggling as IInvoiceType[])),
    [types, typesAfterToggling]
  );

  useEffect(() => {
    setPage(1);
  }, [setPage, currentSearch, invoiceTypes]);

  return {
    page,
    setPage,
    perPage,
    setPerPage,
    searchString,
    setSearchString,
    currentSearch,
    types: typesAfterToggling,
    setTypes,
    invoiceTypes,
    hasActiveFilters: Boolean(currentSearch) || invoiceTypes.length > 0,
  };
};
